import type { ClientOperatingSystem } from "../../types/experiment";
import { SDKVersionEditor } from "../Shared/SDKVersionEditor";

interface ClientOSFilterProps {
  value: ClientOperatingSystem;
  onChange: (value: ClientOperatingSystem) => void;
}

export function ClientOSFilter({ value, onChange }: ClientOSFilterProps) {
  return (
    <div className="grid grid-cols-2 gap-3">
      <SDKVersionEditor
        label="iOS"
        value={value.ios_version}
        onChange={(v) => onChange({ ...value, ios_version: v })}
      />
      <SDKVersionEditor
        label="Android"
        value={value.android_version}
        onChange={(v) => onChange({ ...value, android_version: v })}
      />
      <SDKVersionEditor
        label="macOS"
        value={value.macos_version}
        onChange={(v) => onChange({ ...value, macos_version: v })}
      />
      <SDKVersionEditor
        label="Windows"
        value={value.windows_version}
        onChange={(v) => onChange({ ...value, windows_version: v })}
      />
      <SDKVersionEditor
        label="PlayStation"
        value={value.playstation_version}
        onChange={(v) => onChange({ ...value, playstation_version: v })}
      />
      <SDKVersionEditor
        label="Xbox"
        value={value.xbox_version}
        onChange={(v) => onChange({ ...value, xbox_version: v })}
      />
      <SDKVersionEditor
        label="Linux"
        value={value.linux_version}
        onChange={(v) => onChange({ ...value, linux_version: v })}
      />
    </div>
  );
}
